export default __webpack_public_path__ + "static/mistake-6-00eb08743e7582cd70392dad898d8908.png";